import React from "react";

const About = () => {
  return (
    <>
      <div id="aboutContainer">
        <div>
          <img
            className="aboutBannerImg"
            src="bannerbeawebsitenew.png"
            alt="website banner"
          ></img>
          <div id="aboutIntro">
            {/* <h1 id="aboutHomepageHeader">Who I Am</h1> */}
            <p id="quote">
              "Finding beauty in every corner of the human experience."
            </p>
            <p>
              Front-End Development has always been a huge interest and passion
              of mine. It all began with MySpace. Yep. Perhaps you know where
              I'm heading with this. If not, I digres.
            </p>
            <p>
              I have experience writing on my blog in high school using Blogspot
              to WordPress. Deep within me I always have had a natural knack for
              creativity and design. Additionally, I've always been a
              compassionate, outgoing, people-person.
            </p>
            <p>
              To close, once you get to know me, you'll understand why people
              say I'm an old soul, curious, great attention to detail and
              extremely loyal. I take risks and always am seeking adventure.
            </p>
            <p>Get to know me! Let's chat.</p>
          </div>
        </div>
        <br></br>
        <br></br>
        <div class="resumeContainer">
          <a href="https://docs.google.com/document/d/1Svz1vsbG-kGP7iUDTnZBehUDPuYxRZEIfrNoehzbHVs/edit?usp=sharing" download>
            <img
              className="resumeImg"
              src="jan2021resume.jpg"
              alt="bea del rosario resume"
            ></img>
          </a>
        </div>
        <br></br>
        <br></br>
        {/* <div id="aboutBody">
          <p className="resumeTitle">Education</p>
          <p className="titleHeader">
            Lambda School, Remote, June 2020 – November 2020{" "}
          </p>
          <p className="role">Full-Stack Web Development, Endorsed </p>
          <p>
            Tech:: HTML, CSS, LESS, JavaScript, React., Redux, Git, Redux,
            Node.js, Express, PostgresQL, SQL
          </p>
          <p className="titleHeader">
            LIM College, New York, NY, August 2008 – May 2012
          </p>
          <p className="role">
            Bachelor of Business Administration in Marketing
          </p>
          <br></br>
          <p className="resumeTitle">Professional Experience</p>

          <div className="resumeSection">
            <p className="titleHeader">
              TONAL (Tonal Systems Inc.) | San Francisco, CA, July 2019 – April
              2020
            </p>
            <p className="role">Recruiting Operations Coordinator</p>
            <li>
              Served as a partner to VP of People Operations, Recruiters and
              Hiring Managers, executing on all coordination efforts related to
              specific business units
            </li>
            <li>
              Collaborated with key stakeholders within the organization to
              drive and maintain hiring processes while adhering to tight
              deadlines and service level agreements
            </li>
            <li>
              Scheduled a high volume of interviews: onsite, remote, and via
              Zoom or Hangouts Meet using GoogleHire
            </li>
            <li>
              Defined, built, managed, and communicated key program metrics to
              drive for greater efficiencies and operational effectiveness in
              weekly and monthly reports
            </li>
            <li>
              Took ownership of day-of candidate interviews to ensure candidate
              receives an impeccable onsite experience
            </li>
            <li>
              Planned and executed special projects with partner organizations
              such as Techtonica, Empowered Tech and Women in Hardware, planning
              and executing events and volunteer opportunities{" "}
            </li>
          </div>
          <p className="titleHeader">
            GROUPE INSEARCH | San Francisco, CA, February 2018 – February 2019
            <p className="role">Project Manager</p>
          </p>
          <p className="titleHeader">
            SOULCYCLE INC. | San Francisco, CA & New York, NY, November 2012 –
            February 2018
          </p>
          <p className="role">Full-Time Instructor</p>
        </div> */}
      </div>
    </>
  );
};

export default About;
